import { useQueryStateContext } from 'modules/queryBuilder/contexts';
import { AIQuerySummary, AIQuerySummaryTriggerBtn } from 'ui/queryBuilder';
import { useListId, useUpdateListDescriptionMutation } from '../../../hooks';
import { useSuggestedDescription } from '../../../hooks/useSuggestedDescription';
import { useListDetailsContext } from '../../../contexts/listDetails';
import { usePermissionsContext } from '../../../contexts/permissions';
import { PAGE_VARIATIONS } from '../../../constants';

export const AIQuerySummaryButton = () => {
  const listId = useListId();
  const { query } = useQueryStateContext();
  const { canManageSegmentation, canUseSegmentationAiDescriptions } = usePermissionsContext();
  const props = useSuggestedDescription({ listId, query }); // { description, error, fetchDescription, isLoading }
  const { list, pageVariation } = useListDetailsContext();
  const isExistingStaticList = pageVariation === PAGE_VARIATIONS.STATIC && !!listId;

  const { updateListDescription } = useUpdateListDescriptionMutation(listId);

  const onCommit = (description: string) => {
    if (description !== list.description) {
      updateListDescription(description);
    }
  };

  if (!canUseSegmentationAiDescriptions) return null;

  return (
    <AIQuerySummary
      isReadOnly={!canManageSegmentation || !listId || isExistingStaticList}
      onCommit={onCommit}
      {...props}
    >
      <AIQuerySummaryTriggerBtn />
    </AIQuerySummary>
  );
};
